var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnitionOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.234375,
    y: 0.78125,
    width: 1.9375,
    height: 11.4375,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12922 8.2508H4.10775C4.49809 8.98106 5.12126 9.55994 5.87826 9.89549C6.63526 10.231 7.48268 10.304 8.2859 10.1028C9.08913 9.90161 9.80208 9.43778 10.3115 8.785C10.8209 8.13222 11.0976 7.32793 11.0976 6.49989C11.0976 5.67185 10.8209 4.86756 10.3115 4.21478C9.80208 3.56199 9.08913 3.09816 8.2859 2.89696C7.48268 2.69576 6.63526 2.76873 5.87826 3.10428C5.12126 3.43983 4.49809 4.01872 4.10775 4.74898L1.54688 4.74898V7.66845L2.12922 8.2508ZM9.28839 8.04262C8.98324 8.24662 8.62447 8.35563 8.25741 8.35585L8.2574 4.64392C8.74978 4.64362 9.22212 4.83885 9.57059 5.18671C9.82991 5.44649 10.0064 5.7773 10.0779 6.13734C10.1493 6.49739 10.1124 6.87054 9.97191 7.20964C9.8314 7.54875 9.59355 7.83861 9.28839 8.04262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnitionOn);
export default __webpack_public_path__ + "static/media/ignition_on.66490e72eabc04a8fb5c1d4335abed59.svg";
export { ForwardRef as ReactComponent };